import { render, staticRenderFns } from "./ResultByParts.vue?vue&type=template&id=7c3be8dc&scoped=true&"
import script from "./ResultByParts.vue?vue&type=script&lang=js&"
export * from "./ResultByParts.vue?vue&type=script&lang=js&"
import style0 from "./ResultByParts.vue?vue&type=style&index=0&id=7c3be8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3be8dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
